import React from 'react'
import Catalog from 'blocks.app/catalog/catalog'
import { SCHEDULE_CLASSES_CATALOG_CONFIG } from '../InstancesCatalogSchoolSchedule-types'
import { InstancesCatalogScheduleProps } from './InstancesCatalogSchedule-types'

export const InstancesCatalogSchedule = ({ customFilterList }: InstancesCatalogScheduleProps) => {
    return (
        <Catalog
            type={SCHEDULE_CLASSES_CATALOG_CONFIG.type}
            treeView={SCHEDULE_CLASSES_CATALOG_CONFIG.treeView}
            additionalData={SCHEDULE_CLASSES_CATALOG_CONFIG.additionalData}
            fixedHeader={SCHEDULE_CLASSES_CATALOG_CONFIG.fixedHeader}
            isExistRightToolbar={SCHEDULE_CLASSES_CATALOG_CONFIG.isExistRightToolbar}
            hideHeader={SCHEDULE_CLASSES_CATALOG_CONFIG.hideHeader}
            customFilterList={customFilterList}
        />
    )
}
